import { Capacitor } from "@capacitor/core";

export type AppPlatform = "ios" | "android" | "web";

export function getAppPlatform(): AppPlatform {
  const platform = Capacitor.getPlatform();
  if (platform === "ios" || platform === "android") return platform;
  return "web";
}

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function isWebApp(): boolean {
  return !isNativeApp();
}

export function isIOSApp(): boolean {
  return isNativeApp() && getAppPlatform() === "ios";
}

export function isAndroidApp(): boolean {
  return isNativeApp() && getAppPlatform() === "android";
}

export function getClientPlatform(): AppPlatform {
  return isNativeApp() ? getAppPlatform() : "web";
}

export function isAuditNativeRuntime(): boolean {
  return import.meta.env.VITE_AUDIT_NATIVE === "true";
}

/** Pull to refresh is for Android deploys only. The audit runs it to keep the gesture covered. */
export function shouldUsePullToRefresh(): boolean {
  return isAndroidApp() || isAuditNativeRuntime();
}
